const products = [
    {
        id: 1,
        name: 'Apple iPhone',
        slug: 'iphone',
        price: 1200,
        img: '',
        description: 'este es un iPhone'
    },
    {
        id: 2,
        name: 'Samsung Galaxy',
        slug: 'galaxy',
        price: 1000,
        img: '',
        description: 'este es un Galaxy'
    },
    {
        id: 3,
        name: 'Xiaomi Note',
        slug: 'note',
        price: 300,
        img: '',
        description: 'este es un Xiaomi'
    }
]

export default products